module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration006.9bab84e8.webp";